import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import shortid from 'shortid';
import { resize } from 'mathjs';
import { isEmpty, isEqual } from 'lodash';
import { injectIntl, intlShape } from 'react-intl';
import isMobile from 'ismobilejs';
import domtoimage from 'dom-to-image';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import {
  showNotification,
  hideNotification
} from '../Notifications/Notifications.actions';
import { deactivateScanner } from '../../providers/ScannerProvider/ScannerProvider.actions';
import {
  speak,
  cancelSpeech
} from '../../providers/SpeechProvider/SpeechProvider.actions';
import { moveOrderItem } from '../FixedGrid/utils';
import {
  addBoards,
  changeBoard,
  replaceBoard,
  previousBoard,
  toRootBoard,
  createBoard,
  updateBoard,
  switchBoard,
  createTile,
  deleteTiles,
  editTiles,
  focusTile,
  clickSymbol,
  changeOutput,
  historyRemoveBoard,
  updateApiObjects,
  updateApiObjectsNoChild,
  downloadImages,
  createApiBoard,
  upsertApiBoard,
  changeDefaultBoard,
  getApiPublicBoards,
  getApiMyBoardsSuccess,
  createApiTile,
  editApiTiles,
  deleteApiTiles,
  createApiTiles,
  getProgramLicense,
  reorderApiTiles
} from './Board.actions';
import {
  addBoardCommunicator,
  getApiMyCommunicators,
  verifyAndUpsertCommunicator,
  upsertApiCommunicator
} from '../Communicator/Communicator.actions';
import { disableTour, updateDisplaySettings } from '../App/App.actions';
// import CommunicatorDialog from '../Communicator/CommunicatorDialog';
import TileEditor from './TileEditor';
import messages from './Board.messages';
import Board from './Board.component';
import API from '../../api';
import { fetchSignLanguagePose } from '../../api/signLanguageApi';
import {
  SCANNING_METHOD_AUTOMATIC,
  SCANNING_METHOD_MANUAL
} from '../Settings/Scanning/Scanning.constants';
import { NOTIFICATION_DELAY } from '../Notifications/Notifications.constants';
import { EMPTY_VOICES } from '../../providers/SpeechProvider/SpeechProvider.constants';
import PremiumFeature from '../PremiumFeature';
import {
  IS_BROWSING_FROM_APPLE_TOUCH,
  IS_BROWSING_FROM_SAFARI
} from '../../constants';
import LoadingIcon from '../UI/LoadingIcon';
import { createHashHistory } from 'history'
import CommunicatorDialog from '../Communicator/CommunicatorDialog';

const history = createHashHistory()
//import { isAndroid } from '../../cordova-util';

const ogv = require('ogv');
ogv.OGVLoader.base = process.env.PUBLIC_URL + '/ogv';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export class BoardContainer extends Component {
  static propTypes = {
    /**
     * @ignore
     */
    intl: intlShape.isRequired,
    /**
     * Board history navigation stack
     */
    navHistory: PropTypes.arrayOf(PropTypes.string),
    /**
     * Board to display
     */
    board: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      tiles: PropTypes.arrayOf(PropTypes.object)
    }),
    /**
     * Board output
     */
    output: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        image: PropTypes.string,
        vocalization: PropTypes.string
      })
    ),
    /**
     * Add boards from API
     */
    addBoards: PropTypes.func,
    /**
     * Load board
     */
    changeBoard: PropTypes.func,
    /**
     * Load previous board
     */
    previousBoard: PropTypes.func,
    /**
     * Load root board
     */
    toRootBoard: PropTypes.func,
    historyRemoveBoard: PropTypes.func,
    /**
     * Create board
     */
    createBoard: PropTypes.func,
    updateBoard: PropTypes.func,
    /**
     * Create tile
     */
    createTile: PropTypes.func,
    /**
     * Edit tiles
     */
    editTiles: PropTypes.func,
    /**
     * Delete tiles
     */
    deleteTiles: PropTypes.func,
    /**
     * Focuses a board tile
     */
    focusTile: PropTypes.func,
    /**
     * Change output
     */
    changeOutput: PropTypes.func,
    /**
     * Show notification
     */
    showNotification: PropTypes.func,
    /**
     * Deactivate Scanner
     */
    deactivateScanner: PropTypes.func,
    /**
     * Show display Settings
     */
    displaySettings: PropTypes.object,
    /**
     * Show navigationSettings
     */
    navigationSettings: PropTypes.object,
    /**
     * Show userData
     */
    userData: PropTypes.object,
    /**
     * Scanner Settings
     */
    scannerSettings: PropTypes.object,
    /**
     * Adds a Board to the Active Communicator
     */
    addBoardCommunicator: PropTypes.func.isRequired,
    downloadImages: PropTypes.func,
    lang: PropTypes.string,
    isRootBoardTourEnabled: PropTypes.bool,
    disableTour: PropTypes.func,
    isLiveMode: PropTypes.bool,
    changeDefaultBoard: PropTypes.func
  };

  state = {
    selectedTileIds: [],
    isSaving: false,
    isSelectAll: false,
    isSelecting: false,
    isLocked: false,
    tileEditorOpen: false,
    translatedBoard: null,
    isGettingApiObjects: false,
    copyPublicBoard: false,
    blockedPrivateBoard: false,
    copiedTiles: [],
    isScroll: false,
    totalRows: null,
    boardsApi: [],
    currentBoard: null,
    programLicense: null,
    signLanguageLoading: false,
    signLanguagePoseUrl: null,
    signLanguageError: null,
    openCommunicatorDialog: false
  };
  constructor(props) {
    super(props);
    this.boardRef = React.createRef();
  }

  fetchAndSetBoard = async (boardId) => {
    try {
      const fullBoard = await API.getBoard(boardId);
      if (fullBoard) {
        // Update component state for immediate render
        this.setState({
          currentBoard: fullBoard,
          translatedBoard: this.translateBoard(fullBoard)
        });
        // Also update Redux so other methods that use this.props.board work
        this.props.addBoards([fullBoard]);
        return fullBoard;
      }
    } catch (err) {
      console.error('Failed to fetch board:', boardId, err);
    }
    return null;
  };

  async componentDidMount() {
    const {
      match: {
        params: { id }
      }
    } = this.props;

    const {
      // communicator,
      changeBoard,
      userData,
      history,
      getApiPublicBoards,
      board
    } = this.props;


    try {

      let res = await getApiPublicBoards();
      this.setState({ programLicense: res.license });

      const boardsApi = res.data || [];

    // Loggedin user?
    if ('name' in userData && 'email' in userData && window.navigator.onLine) {
      //synchronize user id in analytics
      window.gtag('set', { user_id: userData.id });
      //synchronize communicator and boards with API
      this.setState({ isGettingApiObjects: true });
    }

    // Find which board to display from the list
    let boardRef = null;
    let boardFetchedDirectly = false;
    if (id) {
      boardRef = boardsApi.find(b => b.id === id || b._id === id);
      if (!boardRef) {
        // Board not in public list (child/folder board) — fetch directly
        try {
          boardRef = await API.getBoard(id);
          boardFetchedDirectly = !!boardRef;
        } catch (e) {
          // Board not found, fall through to root
        }
      }
    }
    if (!boardRef) {
      boardRef = boardsApi.find(b => b.id === 'root');
    }
    if (!boardRef && boardsApi.length > 0) {
      boardRef = boardsApi[0];
    }

    if (!boardRef) {
      return;
    }

    const boardId = boardRef.id || boardRef._id;
    if (boardFetchedDirectly) {
      // Already have full board with tiles — just update state
      this.setState({
        currentBoard: boardRef,
        translatedBoard: this.translateBoard(boardRef)
      });
      this.props.addBoards([boardRef]);
    } else {
      // Fetch the full board with tiles (lazy load)
      await this.fetchAndSetBoard(boardId);
    }

    changeBoard(boardId);
    const goTo = id ? boardId : `board/${boardId}`;
    history.replace(goTo);

    // if (isAndroid()) downloadImages();
    } catch (error) {

    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.match.params.id !== nextProps.match.params.id) {
      const {
        navHistory,
        changeBoard,
        previousBoard,
        historyRemoveBoard
      } = this.props;

      const nextBoardId = nextProps.match.params.id;

      // Check if this is a browser back action
      const isBackAction =
        navHistory.length >= 2 &&
        nextBoardId === navHistory[navHistory.length - 2];

      // Lazy-fetch the board for any navigation (back, switch, etc.)
      this.fetchAndSetBoard(nextBoardId).then(fetchedBoard => {
        if (fetchedBoard) {
          changeBoard(nextBoardId);
          if (isBackAction) {
            previousBoard();
          }
          this.scrollToTop();
        } else if (isBackAction) {
          historyRemoveBoard(nextBoardId);
        }
      });
    }
  }

  toggleSelectMode() {
    this.setState(prevState => ({
      isSelecting: !prevState.isSelecting,
      isSelectAll: false,
      selectedTileIds: []
    }));
  }

  selectAllTiles() {
    const board = this.state.currentBoard || this.props.board;
    const allTileIds = board.tiles.map(tile => tile.id);

    this.setState({
      selectedTileIds: allTileIds
    });
  }

  selectTile(tileId) {
    this.setState({
      selectedTileIds: [...this.state.selectedTileIds, tileId]
    });
  }

  deselectTile(tileId) {
    const [...selectedTileIds] = this.state.selectedTileIds;
    const tileIndex = selectedTileIds.indexOf(tileId);
    selectedTileIds.splice(tileIndex, 1);
    this.setState({ selectedTileIds });
  }

  toggleTileSelect(tileId) {
    if (this.state.selectedTileIds.includes(tileId)) {
      this.deselectTile(tileId);
    } else {
      this.selectTile(tileId);
    }
  }

  async tryRemoteBoard(boardId) {
    const { userData } = this.props;
    const remoteBoard = await API.getBoard(boardId);
    //if requested board is from the user just add it
    if (
      'name' in userData &&
      'email' in userData &&
      remoteBoard.email === userData.email &&
      remoteBoard.author === userData.name
    ) {
      return remoteBoard;
    } else {
      //if requested board is public, ask about copy it
      if (remoteBoard.isPublic) {
        this.setState({ copyPublicBoard: remoteBoard });
      } else {
        this.setState({ blockedPrivateBoard: true });
      }
    }
    return null;
  }

  translateBoard(board) {
    if (!board) {
      return null;
    }

    const { intl } = this.props;
    let name;
    let nameFromKey;
    if (board.nameKey) {
      const nameKeyArray = board.nameKey.split('.');
      nameFromKey = nameKeyArray[nameKeyArray.length - 1];
    }
    if (board.nameKey && !board.name) {
      // name = intl.formatMessage({ id: board.nameKey });
      name = board.nameKey;
    } else if (
      board.nameKey &&
      board.name &&
      nameFromKey === board.name &&
      intl.messages[board.nameKey]
    ) {
      name = intl.formatMessage({ id: board.nameKey });
    } else {
      name = board.name;
    }
    const validTiles = board.tiles.filter(tile => (tile ? true : false));
    const tiles = validTiles.map(tile => ({
      ...tile,
      label:
        tile.labelKey && intl.messages[tile.labelKey]
          ? intl.formatMessage({ id: tile.labelKey })
          : tile.label
    }));

    const translatedBoard = {
      ...board,
      name,
      tiles
    };

    return translatedBoard;
  }

  async captureBoardScreenshot() {
    const node = document.getElementById('BoardTilesContainer').firstChild;
    let dataURL = null;
    try {
      dataURL = await domtoimage.toPng(node);
    } catch (e) {}

    return dataURL;
  }

  async updateBoardScreenshot() {
    let url = null;
    const dataURL = await this.captureBoardScreenshot();
    if (dataURL && dataURL !== 'data:,') {
      const filename = `${this.state.translatedBoard.name ||
        this.state.translatedBoard.id}.png`;
      url = await API.uploadFromDataURL(dataURL, filename);
    }

    return url;
  }

  async playAudio(src) {
    const safariNeedHelp =
      (IS_BROWSING_FROM_SAFARI || IS_BROWSING_FROM_APPLE_TOUCH) &&
      src.endsWith('.ogg');
    const audio = safariNeedHelp ? new ogv.OGVPlayer() : new Audio();
    audio.src = src;
    await audio.play();
  }

  handleOpenCommunicatorDialog = () => {
    this.setState({ openCommunicatorDialog: true });
  };

  handleCloseCommunicatorDialog = () => {
    this.setState({ openCommunicatorDialog: false });
  };

  // handleEditCommunicatorTitle = async name => {
  //   const {
  //     currentCommunicator,
  //     verifyAndUpsertCommunicator,
  //     upsertApiCommunicator,
  //     userData
  //   } = this.props;

  //   const updatedCommunicatorData = {
  //     ...currentCommunicator,
  //     name
  //   };

  //   const upsertedCommunicator = verifyAndUpsertCommunicator(
  //     updatedCommunicatorData
  //   );

  //   if ('name' in userData && 'email' in userData) {
  //     try {
  //       await upsertApiCommunicator(upsertedCommunicator);
  //     } catch (err) {
  //       console.error('Error upserting communicator', err);
  //     }
  //   }
  // };

  handleEditBoardTitle = name => {
    const board = this.state.currentBoard || this.props.board;
    const { updateBoard } = this.props;
    const titledBoard = {
      ...board,
      name: name
    };
    const processedBoard = this.updateIfFeaturedBoard(titledBoard);
    updateBoard(processedBoard);
    this.saveApiBoardOperation(processedBoard);
  };

  saveApiBoardOperation = async board => {
    const {
      userData,
      replaceBoard,
      updateApiObjectsNoChild,
      lang,
    } = this.props;

    var createBoard = false;
    this.setState({ isSaving: true });
    try {
      //prepare board
      let boardData = {
        ...board,
        author: userData.name || board.author,
        email: userData.email || board.email,
        hidden: false,
        locale: lang
      };
      // Board has _id means it already exists in the API - update it
      // Otherwise check shortid length to decide create vs update
      const hasApiId = !!boardData._id;
      if (!hasApiId && boardData.id.length < 14) {
        createBoard = true;
        boardData = {
          ...boardData,
          isPublic: false
        };
      } else {
        // Use _id for the API call if available
        if (hasApiId && boardData.id !== boardData._id.toString()) {
          boardData = { ...boardData, id: boardData._id.toString() };
        }
        //update the board
        updateBoard(boardData);
      }
      //api updates
      const boardId = await updateApiObjectsNoChild(
        boardData,
        createBoard
      );
      if (createBoard && boardId) {
        replaceBoard({ ...boardData }, { ...boardData, id: boardId });
        this.props.history.replace(`/board/${boardId}`);
      }
    } catch (err) {
      console.log(err.message);
    } finally {
      this.setState({ isSaving: false });
    }
  };

  handleEditClick = () => {
    this.setState({ tileEditorOpen: true });
  };

  handleTileEditorCancel = () => {
    this.setState({ tileEditorOpen: false });
  };

  handleEditTileEditorSubmit = async tiles => {
    const board = this.state.currentBoard || this.props.board;
    const { editApiTiles } = this.props;
    this.updateIfFeaturedBoard(board);
    await editApiTiles(tiles, board.id || board._id);
    this.toggleSelectMode();
    // Re-fetch the current board to get fresh tile data
    await this.fetchAndSetBoard(board.id || board._id);
  };

  handleAddTileEditorSubmit = async tile => {
    const board = this.state.currentBoard || this.props.board;
    const { createApiTile, createApiBoard } = this.props;

    if (tile.type === 'board') {
      // Board type: create only a board (no tile), appears in dropdown
      const res = await API.createBoard({
        nameKey: tile.label,
        hidden: false,
        isPublic: true,
        tiles: []
      });
      // Refresh boards list in Redux
      const resBoards = await API.getPublicBoards({ limit: 10000 });
      this.props.getApiMyBoardsSuccess(resBoards);
      // Navigate to the newly created board
      if (res && res.id) {
        await this.fetchAndSetBoard(res.id);
        this.props.changeBoard(res.id);
      }
    } else {
      await createApiTile(tile, board.id || board._id);
      await this.fetchAndSetBoard(board.id || board._id);
    }
  };

  updateIfFeaturedBoard = board => {
    const { userData, updateBoard, intl, lang } = this.props;
    let boardData = {
      ...board
    };
    if (
      'name' in userData &&
      'email' in userData &&
      board.email !== userData.email
    ) {
      boardData = {
        ...boardData,
        name:
          board.name ||
          this.nameFromKey(board) ||
          intl.formatMessage(messages.myBoardTitle),
        author: userData.name,
        email: userData.email,
        hidden: false,
        isPublic: false,
        locale: lang
      };
      updateBoard(boardData);
    }
    return boardData;
  };

  nameFromKey = board => {
    let nameFromKey = undefined;
    if (board.nameKey) {
      const nameKeyArray = board.nameKey.split('.');
      nameFromKey = nameKeyArray[nameKeyArray.length - 1];
    }
    return nameFromKey;
  };

  handleAddClick = () => {
    this.setState({
      tileEditorOpen: true,
      selectedTileIds: [],
      isSelecting: false
    });
  };

  handleAddRemoveRow = async (isAdd, isLeftOrTop) => {
    const board = this.state.currentBoard || this.props.board;
    const { updateBoard } = this.props;
    if ((!isAdd && board.grid.rows > 1) || (isAdd && board.grid.rows < 12)) {
      let newOrder = [];
      const newRows = isAdd ? board.grid.rows + 1 : board.grid.rows - 1;
      if (Array.isArray(board.grid.order) && board.grid.order.length) {
        newOrder = resize(
          board.grid.order,
          [newRows, board.grid.columns],
          null
        );
      } else {
        newOrder = this.getDefaultOrdering(board.tiles);
      }
      const newBoard = {
        ...board,
        grid: {
          ...board.grid,
          rows: newRows,
          order: newOrder
        }
      };
      const processedBoard = this.updateIfFeaturedBoard(newBoard);
      updateBoard(processedBoard);
      this.saveApiBoardOperation(processedBoard);
    }
  };

  handleAddRemoveColumn = async (isAdd, isLeftOrTop) => {
    const board = this.state.currentBoard || this.props.board;
    const { updateBoard } = this.props;
    if (
      (!isAdd && board.grid.columns > 1) ||
      (isAdd && board.grid.columns < 12)
    ) {
      let newOrder = [];
      const newColumns = isAdd
        ? board.grid.columns + 1
        : board.grid.columns - 1;
      if (Array.isArray(board.grid.order) && board.grid.order.length) {
        newOrder = resize(
          board.grid.order,
          [board.grid.rows, newColumns],
          null
        );
      } else {
        newOrder = this.getDefaultOrdering(board.tiles);
      }
      const newBoard = {
        ...board,
        grid: {
          ...board.grid,
          columns: newColumns,
          order: newOrder
        }
      };
      const processedBoard = this.updateIfFeaturedBoard(newBoard);
      updateBoard(processedBoard);
      this.saveApiBoardOperation(processedBoard);
    }
  };

  _isDragging = false;

  handleGridDragStart = () => {
    this._isDragging = true;
  };

  handleGridDragStop = () => {
    this._isDragging = false;
  };

  handleLayoutChange = (currentLayout, layouts) => {
    if (this._isDragging) return;
    const { updateBoard, replaceBoard, navigationSettings, reorderApiTiles } = this.props;
    const board = this.state.currentBoard || this.props.board;
    currentLayout.sort((a, b) => {
      if (a.y === b.y) {
        return a.x - b.x;
      } else if (a.y > b.y) {
        return 1;
      }
      return -1;
    });

    const tilesIds = currentLayout.map(gridTile => gridTile.i);
    const tiles = tilesIds.map(t => {
      return board.tiles.find(tile => {
        if (!tile) {
          return false;
        }
        return tile.id === t || Number(tile.id) === Number(t);
      });
    });

    if (navigationSettings.bigScrollButtonsActive) {
      const cols =
        currentLayout.reduce(function(valorAnterior, item) {
          if (item.x > valorAnterior) return item.x;
          return valorAnterior;
        }, 0) + 1;
      const rows = 3;
      const isScroll = currentLayout.length / cols > rows ? true : false;
      const totalRows = Math.ceil(currentLayout.length / cols);
      this.setIsScroll(isScroll, totalRows);
    }

    if (!isEqual(board.tiles, tiles)) {
      const newBoard = { ...board, tiles };
      replaceBoard(board, newBoard);
      const processedBoard = this.updateIfFeaturedBoard(newBoard);
      updateBoard(processedBoard);
      const tilesOrder = tiles
        .filter(t => t)
        .map((tile, i) => ({ tileId: tile._id || tile.id, order: i }));
      reorderApiTiles(tilesOrder, board._id || board.id);
    }
  };

  setIsScroll = (bool, totalRows = 0) => {
    this.setState({ isScroll: bool, totalRows: totalRows });
  };

  handleTileDrop = async (tile, position) => {
    const board = this.state.currentBoard || this.props.board;
    const { updateBoard } = this.props;
    const newOrder = moveOrderItem(tile.id, position, board.grid.order);

    const newBoard = {
      ...board,
      grid: {
        ...board.grid,
        order: newOrder
      }
    };
    const processedBoard = this.updateIfFeaturedBoard(newBoard);
    updateBoard(processedBoard);
    this.saveApiBoardOperation(processedBoard);
  };

  handleLockClick = () => {
    this.setState((state, props) => ({
      isLocked: !state.isLocked,
      isSaving: false,
      isSelecting: false,
      selectedTileIds: []
    }));
  };

  handleSelectClick = () => {
    this.toggleSelectMode();
  };

  handleSelectAllToggle = () => {
    if (this.state.isSelectAll) {
      this.setState({ selectedTileIds: [] });
    } else {
      this.selectAllTiles();
    }

    this.setState(prevState => ({
      isSelectAll: !prevState.isSelectAll
    }));
  };

  handleTileClick = async tile => {
    if (this.state.isSelecting) {
      this.toggleTileSelect(tile.id);
      return;
    }

    const {
      changeBoard,
      changeOutput,
      clickSymbol,
      speak,
      intl,
      boards,
      addBoards,
      showNotification,
      navigationSettings,
      isLiveMode
    } = this.props;
    const hasAction = tile.action && tile.action.startsWith('+');

    const say = () => {
      if (tile.sound) {
        this.playAudio(tile.sound);
      } else {
        const toSpeak = !hasAction ? tile.vocalization || tile.label : null;
        if (toSpeak) {
          speak(toSpeak);
        }
      }
    };
    if (tile.loadBoard) {
      // Fetch the board from API (lazy loading)
      const fetchedBoard = await this.fetchAndSetBoard(tile.loadBoard);
      if (fetchedBoard) {
        changeBoard(fetchedBoard.id || fetchedBoard._id);
        this.props.history.push(fetchedBoard.id || fetchedBoard._id);
        if (navigationSettings.vocalizeFolders) {
          say();
        }
      } else {
        showNotification(intl.formatMessage(messages.boardMissed));
      }
    } else {
      clickSymbol(tile.label);
      if (!navigationSettings.quietBuilderMode) {
        say();
      }
      if (isLiveMode) {
        const liveTile = {
          backgroundColor: 'rgb(255, 241, 118)',
          id: shortid.generate(),
          image: '',
          label: '',
          labelKey: '',
          type: 'live'
        };
        changeOutput([...this.props.output, tile, liveTile]);
      } else {
        changeOutput([...this.props.output, tile]);
      }
    }
  };

  handleAddTile = (tile, boardId) => {
    const { intl, createTile, showNotification } = this.props;
    createTile(tile, boardId);
    showNotification(intl.formatMessage(messages.tilesCreated));
  };

  handleDeleteClick = async () => {
    const { intl, deleteApiTiles, showNotification } = this.props;
    const board = this.state.currentBoard || this.props.board;
    this.updateIfFeaturedBoard(board);
    const res = await deleteApiTiles(this.state.selectedTileIds, board.id || board._id);

    this.setState({
      selectedTileIds: []
    });
    showNotification(res.message);
    this.toggleSelectMode();
    // Re-fetch the current board to get fresh tile data
    await this.fetchAndSetBoard(board.id || board._id);
  };

  handleLockNotify = countdown => {
    const { intl, showNotification, hideNotification } = this.props;

    if (countdown > 3) {
      return;
    }

    if (!countdown) {
      hideNotification();
      return;
    }

    const clicksToUnlock = `${countdown} ${intl.formatMessage(
      messages.clicksToUnlock
    )} SIUU`;

    hideNotification();
    // HACK: refactor Notification container
    setTimeout(() => {
      showNotification(clicksToUnlock);
    });
  };

  handleScannerStrategyNotification = () => {
    const {
      scannerSettings: { strategy },
      showNotification,
      intl
    } = this.props;
    const messagesKeyMap = {
      [SCANNING_METHOD_MANUAL]: messages.scannerManualStrategy,
      [SCANNING_METHOD_AUTOMATIC]: messages.scannerAutomaticStrategy
    };
    showNotification(intl.formatMessage(messagesKeyMap[strategy]));

    if (!isMobile.any) {
      setTimeout(() => {
        showNotification(intl.formatMessage(messages.scannerHowToDeactivate));
      }, NOTIFICATION_DELAY);
    }
  };

  async uploadTileSound(tile) {
    if (tile && tile.sound && tile.sound.startsWith('data')) {
      const { userData } = this.props;
      try {
        var blob = new Blob([this.convertDataURIToBinary(tile.sound)], {
          type: 'audio/mp3; codecs=opus'
        });
        const audioUrl = await API.uploadFile(blob, userData.email + '.mp3');
        tile.sound = audioUrl;
      } catch (err) {
        console.log(err.message);
      }
    }
    return tile;
  }

  convertDataURIToBinary(dataURI) {
    var BASE64_MARKER = ';base64,';
    var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
    var base64 = dataURI.substring(base64Index);
    var raw = window.atob(base64);
    var rawLength = raw.length;
    var array = new Uint8Array(new ArrayBuffer(rawLength));

    for (let i = 0; i < rawLength; i++) {
      array[i] = raw.charCodeAt(i);
    }
    return array;
  }

  handleApiUpdates = async (
    tile = null,
    deletedTilesiIds = null,
    editedTiles = null,
    processedBoard = null
  ) => {
    const {
      userData,
      // communicator,
      intl,
      // verifyAndUpsertCommunicator,
      updateApiObjectsNoChild,
      updateApiObjects,
      replaceBoard,
      updateBoard,
      switchBoard,
      lang
    } = this.props;
    const board = this.state.currentBoard || this.props.board;
    const authorName = userData.name || board.author;
    const authorEmail = userData.email || board.email;

    this.setState({
      isSaving: true
    });

    if (tile && tile.sound && tile.sound.startsWith('data')) {
      tile = await this.uploadTileSound(tile);
    }
    if (editedTiles) {
      let _editedTiles = [];
      for (let _tile of editedTiles) {
        _editedTiles.push(await this.uploadTileSound(_tile));
      }
      editedTiles = _editedTiles;
    }

    var createParentBoard = false;
    var createChildBoard = false;
    var childBoardData = null;

    let uTiles = [];
    if (deletedTilesiIds) {
      uTiles = board.tiles.filter(
        cTile => !deletedTilesiIds.includes(cTile.id)
      );
    }
    if (editedTiles) {
      uTiles = board.tiles.map(
        cTile => editedTiles.find(s => s.id === cTile.id) || cTile
      );
    }
    if (tile && tile.type !== 'board') {
      uTiles = board.tiles.find(t => t.id === tile.id)
        ? [...board.tiles]
        : [...board.tiles, tile];
    }
    if (tile && tile.type === 'board') {
      uTiles = [...board.tiles];
    }

    let parentBoardData = processedBoard
      ? processedBoard
      : {
          ...board,
          name:
            board.name ||
            this.nameFromKey(board) ||
            intl.formatMessage(messages.myBoardTitle),
          tiles: uTiles,
          author: authorName,
          email: authorEmail,
          hidden: false,
          locale: lang
        };
    //check for a new  own board
    if (tile && tile.loadBoard && !tile.linkedBoard) {
      const boardData = {
        id: tile.loadBoard,
        name: tile.label,
        nameKey: tile.labelKey,
        hidden: false,
        tiles: [],
        isPublic: false,
        author: authorName,
        email: authorEmail,
        locale: lang,
        caption: tile.image
      };
      childBoardData = { ...boardData };
      createChildBoard = true;
      updateBoard(childBoardData);
    }
    //check if we have to create a copy of the parent
    const hasParentApiId = !!parentBoardData._id;
    if (!hasParentApiId && parentBoardData.id.length < 14) {
      createParentBoard = true;
      parentBoardData = {
        ...parentBoardData,
        isPublic: false
      };
    } else {
      // Use _id for the API call if available
      if (hasParentApiId && parentBoardData.id !== parentBoardData._id.toString()) {
        parentBoardData = { ...parentBoardData, id: parentBoardData._id.toString() };
      }
      //update the parent
      updateBoard(parentBoardData);
    }
    // Untill here all is with shorts ids
    //api updates
    if (tile && tile.type === 'board') {
      //child becomes parent
      updateApiObjectsNoChild(childBoardData, true)
        .then(parentBoardId => {
          switchBoard(parentBoardId);
          this.props.history.replace(`/board/${parentBoardId}`, []);
          this.setState({ isSaving: false });
        })
        .catch(e => {
          this.setState({ isSaving: false });
        });
    } else {
      if (!createChildBoard) {
        updateApiObjectsNoChild(parentBoardData, createParentBoard)
          .then(parentBoardId => {
            if (createParentBoard) {
              replaceBoard(
                { ...parentBoardData },
                { ...parentBoardData, id: parentBoardId }
              );
            }
            this.props.history.replace(`/board/${parentBoardId}`);
            this.setState({ isSaving: false });
          })
          .catch(e => {
            this.setState({ isSaving: false });
          });
      } else {
        updateApiObjects(childBoardData, parentBoardData, createParentBoard)
          .then(parentBoardId => {
            if (createParentBoard) {
              replaceBoard(
                { ...parentBoardData },
                { ...parentBoardData, id: parentBoardId }
              );
            }
            this.props.history.replace(`/board/${parentBoardId}`);
            this.setState({ isSaving: false });
          })
          .catch(e => {
            this.setState({ isSaving: false });
          });
      }
    }
  };

  onRequestPreviousBoard() {
    if (this.props.navHistory.length >= 2) {
      const prevBoardId = this.props.navHistory[
        this.props.navHistory.length - 2
      ];
      this.props.history.replace(`/board/${prevBoardId}`);
      this.scrollToTop();
    }
  }

  onRequestToRootBoard() {
    this.props.toRootBoard();
    this.scrollToTop();
  }

  scrollToTop() {
    if (this.boardRef && !this.state.isSelecting) {
      if (this.boardRef.current && this.boardRef.current.boardContainerRef) {
        this.boardRef.current.boardContainerRef.current.scrollTop = 0;
      }
    }
  }

  handleCopyRemoteBoard = async () => {
    const { intl, showNotification, history, switchBoard } = this.props;
    try {
      this.setState({
        isSaving: true
      });
      const copiedBoard = await this.createBoardsRecursively(
        this.state.copyPublicBoard
      );
      if (!copiedBoard?.id) {
        throw new Error('Board not copied correctly');
      }
      switchBoard(copiedBoard.id);
      history.replace(`/board/${copiedBoard.id}`, []);
      const translatedBoard = this.translateBoard(copiedBoard);
      this.setState({
        translatedBoard,
        copyPublicBoard: false,
        blockedPrivateBoard: false
      });
      showNotification(intl.formatMessage(messages.boardCopiedSuccessfully));
    } catch (err) {
      console.log(err.message);
      showNotification(intl.formatMessage(messages.boardCopyError));
      this.handleCloseDialog();
    }
    this.setState({
      isSaving: false
    });
  };

  async createBoardsRecursively(board, records) {
    const {
      createBoard,
      // addBoardCommunicator,
      // communicator,
      userData,
      updateApiObjectsNoChild,
      boards,
      intl,
      // verifyAndUpsertCommunicator
    } = this.props;

    //prevent shit
    if (!board) {
      return null;
    }
    if (records) {
      //get the list of next boards in records
      let nextBoardsRecords = records.map(entry => entry.next);
      if (nextBoardsRecords.includes(board.id)) {
        return null;
      }
    }

    let newBoard = {
      ...board,
      isPublic: false,
      id: shortid.generate(),
      hidden: false,
      author: '',
      email: ''
    };
    if (!newBoard.name) {
      newBoard.name = newBoard.nameKey
        ? intl.formatMessage({ id: newBoard.nameKey })
        : intl.formatMessage(messages.noTitle);
    }
    newBoard = {
      ...newBoard,
      author: userData.name || board.author || '',
      email: userData.email || board.email || ''
    };
    createBoard(newBoard);

    if (!records) {
      records = [{ prev: board.id, next: newBoard.id }];
    } else {
      records.push({ prev: board.id, next: newBoard.id });
    }
    this.updateBoardReferences(board, newBoard, records);

    try {
      const boardId = await updateApiObjectsNoChild(newBoard, true);
      newBoard = {
        ...newBoard,
        id: boardId
      };
    } catch (err) {
      console.log(err.message);
    }

    if (board.tiles.length < 1) {
      return newBoard;
    }

    //return condition
    for (const tile of board.tiles) {
      if (tile.loadBoard && !tile.linkedBoard) {
        try {
          const nextBoard = await API.getBoard(tile.loadBoard);
          await this.createBoardsRecursively(nextBoard, records);
        } catch (err) {
          if (!err.respose || err.response?.status === 404) {
            //look for this board in available boards
            const localBoard = boards.find(b => b.id === tile.loadBoard);
            if (localBoard) {
              await this.createBoardsRecursively(localBoard, records);
            }
          }
        }
      }
    }
    return newBoard;
  }

  updateBoardReferences(board, newBoard, records) {
    const { boards, updateBoard } = this.props;
    //get the list of prev boards in records, but remove the current board
    let prevBoardsRecords = records.map(entry => entry.prev);
    prevBoardsRecords = prevBoardsRecords.filter(id => id !== newBoard.id);
    //look for reference to the original board id
    boards.forEach(b => {
      b.tiles.forEach((tile, index) => {
        if (
          //general case: tile can contains reference to the board
          tile &&
          tile.loadBoard &&
          tile.loadBoard === board.id
        ) {
          b.tiles.splice(index, 1, {
            ...tile,
            loadBoard: newBoard.id
          });
          try {
            updateBoard(b);
          } catch (err) {
            console.log(err.message);
          }
        }
        if (
          //special case: tile can contains reference to a prev board in records!
          tile &&
          tile.loadBoard &&
          prevBoardsRecords.includes(tile.loadBoard)
        ) {
          const el = records.find(e => e.prev === tile.loadBoard);
          b.tiles.splice(index, 1, {
            ...tile,
            loadBoard: el.next
          });
          try {
            updateBoard(b);
          } catch (err) {
            console.log(err.message);
          }
        }
      });
    });
  }

  handleCloseDialog = (event, reason) => {
    const { isSaving } = this.state;
    if (isSaving) return;
    this.setState({
      copyPublicBoard: false,
      blockedPrivateBoard: false
    });
  };

  publishBoard = () => {
    const board = this.state.currentBoard || this.props.board;
    const { updateBoard } = this.props;
    const newBoard = {
      ...board,
      isPublic: !board.isPublic
    };
    const processedBoard = this.updateIfFeaturedBoard(newBoard);
    updateBoard(processedBoard);
    this.saveApiBoardOperation(processedBoard);
  };

  handleBigTileModeToggle = async () => {
    const { displaySettings, updateDisplaySettings } = this.props;
    const newValue = !displaySettings.bigTileMode;
    const newDisplay = { ...displaySettings, bigTileMode: newValue };
    updateDisplaySettings(newDisplay);
    try {
      await API.updateSettings({ display: newDisplay });
    } catch (e) {}
  };

  handleCopyTiles = () => {
    const { intl, showNotification } = this.props;
    const copiedTiles = this.selectedTiles();
    this.setState({
      copiedTiles: copiedTiles
    });
    showNotification(intl.formatMessage(messages.tilesCopiedSuccessfully));
  };

  handlePasteTiles = async () => {
    const board = this.state.currentBoard || this.props.board;
    const { intl, showNotification, createApiTiles } = this.props;
    try {
      this.setState({ isSaving: true });
      await createApiTiles(this.state.copiedTiles, board.id || board._id);
      // for await (const tile of this.state.copiedTiles) {
        // const newTile = {
        //   ...tile,
        //   id: shortid.generate()
        // };
        // if (tile.loadBoard) {
          // createApiTile(tile, board.id);
          // await this.pasteBoardsRecursively(newTile, board.id, tile.loadBoard);
        // } else {
        //   await this.handleAddTileEditorSubmit(newTile);
        // }
      // }
      showNotification(intl.formatMessage(messages.tilesPastedSuccessfully));
      // Re-fetch the current board to get fresh tile data
      await this.fetchAndSetBoard(board.id || board._id);
    } catch (err) {
      showNotification(intl.formatMessage(messages.tilesPastedError));
      console.error(err.message);
    } finally {
      this.setState({ isSaving: false });
    }
  };

  // async pasteBoardsRecursively(folderTile, parentBoardId, firstPastedFolderId) {
  //   const {
  //     createBoard,
  //     userData,
  //     updateBoard,
  //     createApiBoard,
  //     boards,
  //     intl
  //   } = this.props;

  //   //prevent shit
  //   if (!folderTile || !folderTile.loadBoard) {
  //     return;
  //   }

  //   let newBoard = {
  //     ...boards.find(b => b.id === folderTile.loadBoard),
  //     isPublic: false,
  //     id: shortid.generate(),
  //     hidden: false,
  //     author: '',
  //     email: ''
  //   };

  //   const tilesWithFatherRemoved = newBoard.tiles?.reduce((newTiles, tile) => {
  //     if (firstPastedFolderId !== tile.loadBoard) newTiles.push(tile);
  //     return newTiles;
  //   }, []);

  //   newBoard.tiles = tilesWithFatherRemoved;

  //   if (!newBoard.name) {
  //     newBoard.name = newBoard.nameKey
  //       ? intl.formatMessage({ id: newBoard.nameKey })
  //       : intl.formatMessage(messages.noTitle);
  //   }
  //   if ('name' in userData && 'email' in userData) {
  //     newBoard = {
  //       ...newBoard,
  //       author: userData.name,
  //       email: userData.email
  //     };
  //   }
  //   // Prevent creating a board without the tiles property
  //   if (newBoard.tiles) createBoard(newBoard);
  //   // Loggedin user?
  //   if ('name' in userData && 'email' in userData) {
  //     try {
  //       newBoard = await createApiBoard(newBoard, newBoard.id);
  //     } catch (err) {
  //       console.error(err.message);
  //     }
  //   }
  //   const parentBoard = boards.find(b => b.id === parentBoardId);
  //   const newTiles = parentBoard.tiles.map(tile =>
  //     tile && tile.id === folderTile.id
  //       ? { ...tile, loadBoard: newBoard.id }
  //       : tile
  //   );
  //   const boardData = { ...parentBoard, tiles: newTiles };
  //   updateBoard(boardData);
  //   // Loggedin user?
  //   if ('name' in userData && 'email' in userData) {
  //     try {
  //       let newParentBoard = {
  //         ...boardData,
  //         hidden: false,
  //         author: userData.name,
  //         email: userData.email
  //       };
  //       if (!newParentBoard.name) {
  //         newParentBoard.name = newParentBoard.nameKey
  //           ? intl.formatMessage({ id: newParentBoard.nameKey })
  //           : intl.formatMessage(messages.noTitle);
  //       }
  //       await this.handleApiUpdates('', '', '', newParentBoard);
  //     } catch (err) {
  //       console.error(err.message);
  //     }
  //   }

  //   //return condition
  //   for await (const tile of newBoard.tiles) {
  //     if (tile && tile.loadBoard && !tile.linkedBoard) {
  //       //look for this board in available boards
  //       const newBoardToCopy = boards.find(b => b.id === tile.loadBoard);
  //       if (newBoardToCopy) {
  //         await this.pasteBoardsRecursively(
  //           tile,
  //           newBoard.id,
  //           firstPastedFolderId
  //         );
  //       }
  //     }
  //   }
  //   return;
  // }

  selectedTiles = () => {
    const board = this.state.currentBoard || this.props.board;
    return this.state.selectedTileIds
      ? this.state.selectedTileIds.map(selectedTileId => {
          const tiles = (board.tiles || []).filter(tile => {
            return tile.id === selectedTileId;
          })[0];

          return tiles;
        })
      : [];
  };

  handleSignLanguageRequest = async phrase => {
    const { lang } = this.props;

    if (this.state.signLanguagePoseUrl) {
      URL.revokeObjectURL(this.state.signLanguagePoseUrl);
    }

    this.setState({
      signLanguageLoading: true,
      signLanguagePoseUrl: null,
      signLanguageError: null,
      signLanguageFallback: false
    });

    try {
      const { blobUrl, isFallback } = await fetchSignLanguagePose(phrase, 'ase');
      this.setState({
        signLanguageLoading: false,
        signLanguagePoseUrl: blobUrl,
        signLanguageFallback: isFallback
      });
    } catch (err) {
      console.error('Sign language API error:', err);
      this.setState({
        signLanguageLoading: false,
        signLanguageError: err.message || 'Failed to generate sign language animation'
      });
    }
  };

  handleSignLanguageClose = () => {
    if (this.state.signLanguagePoseUrl) {
      URL.revokeObjectURL(this.state.signLanguagePoseUrl);
    }
    this.setState({
      signLanguageLoading: false,
      signLanguagePoseUrl: null,
      signLanguageError: null
    });
  };

  render() {
    const {
      navHistory,
      focusTile,
      isPremiumRequiredModalOpen,
      improvedPhrase,
      speak,
      boards,
      // communicator
    } = this.props;

    const board = this.state.currentBoard || this.props.board;

    const disableBackButton = navHistory.length === 1;
    const editingTiles = this.state.tileEditorOpen && board
      ? this.state.selectedTileIds.map(selectedTileId => {
          const tiles = (board.tiles || []).filter(tile => {
            return tile.id === selectedTileId;
          })[0];

          return tiles;
        })
      : [];

    return (
      <div>
        {
          !board ?
          <div className="Board__loading">
            <CircularProgress size={60} thickness={5} color="inherit" />
          </div>
          :
          <Fragment>
            <Board
              board={this.translateBoard(board)}
              intl={this.props.intl}
              scannerSettings={this.props.scannerSettings}
              deactivateScanner={this.props.deactivateScanner}
              disableBackButton={disableBackButton}
              userData={this.props.userData}
              isLocked={this.state.isLocked}
              isSaving={this.state.isSaving}
              isSelecting={this.state.isSelecting}
              isSelectAll={this.state.isSelectAll}
              isRootBoardTourEnabled={this.props.isRootBoardTourEnabled}
              isUnlockedTourEnabled={this.props.isUnlockedTourEnabled}
              // updateBoard={this.handleUpdateBoard}
              onAddClick={this.handleAddClick}
              onDeleteClick={this.handleDeleteClick}
              onEditClick={this.handleEditClick}
              onSelectAllToggle={this.handleSelectAllToggle}
              onFocusTile={focusTile}
              onLockClick={this.handleLockClick}
              onLockNotify={this.handleLockNotify}
              onScannerActive={this.handleScannerStrategyNotification}
              onRequestPreviousBoard={this.onRequestPreviousBoard.bind(this)}
              onRequestToRootBoard={this.onRequestToRootBoard.bind(this)}
              onSelectClick={this.handleSelectClick}
              onTileClick={this.handleTileClick}
              editBoardTitle={this.handleEditBoardTitle}
              selectedTileIds={this.state.selectedTileIds}
              displaySettings={this.props.displaySettings}
              navigationSettings={this.props.navigationSettings}
              navHistory={this.props.navHistory}
              publishBoard={this.publishBoard}
              showNotification={this.props.showNotification}
              emptyVoiceAlert={this.props.emptyVoiceAlert}
              offlineVoiceAlert={this.props.offlineVoiceAlert}
              onAddRemoveColumn={this.handleAddRemoveColumn}
              onAddRemoveRow={this.handleAddRemoveRow}
              onTileDrop={this.handleTileDrop}
              onLayoutChange={this.handleLayoutChange}
              onGridDragStart={this.handleGridDragStart}
              onGridDragStop={this.handleGridDragStop}
              disableTour={this.props.disableTour}
              onCopyTiles={this.handleCopyTiles}
              onPasteTiles={this.handlePasteTiles}
              copiedTiles={this.state.copiedTiles}
              setIsScroll={this.setIsScroll}
              isScroll={this.state.isScroll}
              totalRows={this.state.totalRows}
              ref={this.boardRef}
              changeDefaultBoard={this.props.changeDefaultBoard}
              improvedPhrase={improvedPhrase}
              speak={speak}
              license={this.state.programLicense}
              onSignLanguageRequest={this.handleSignLanguageRequest}
              signLanguageLoading={this.state.signLanguageLoading}
              signLanguagePoseUrl={this.state.signLanguagePoseUrl}
              signLanguageError={this.state.signLanguageError}
              signLanguageFallback={this.state.signLanguageFallback}
              onSignLanguageClose={this.handleSignLanguageClose}
              navbarPosition={this.props.navbarPosition}
              communicatorBoards={this.props.communicatorBoards}
              currentCommunicator={this.props.currentCommunicator}
              openCommunicatorDialog={this.handleOpenCommunicatorDialog}
              switchBoard={this.props.switchBoard}
              editCommunicatorTitle={this.handleEditCommunicatorTitle}
              history={this.props.history}
              tilesPerRow={this.props.tilesPerRow}
              tileSpacing={this.props.tileSpacing}
              outputBarPosition={this.props.outputBarPosition}
              toolbarLayout={this.props.toolbarLayout}
              toolbarPosition={this.props.toolbarPosition}
              bigTileMode={!!this.props.displaySettings.bigTileMode}
              onBigTileModeToggle={this.handleBigTileModeToggle}
            />
            {this.state.openCommunicatorDialog && (
              <CommunicatorDialog
                open={this.state.openCommunicatorDialog}
                onClose={this.handleCloseCommunicatorDialog}
                history={history}
                onBoardDeleted={async () => {
                  this.handleCloseCommunicatorDialog();
                  await this.fetchAndSetBoard('root');
                  this.props.changeBoard('root');
                  history.replace('/board/root');
                }}
              />
            )}
            <Dialog
              open={!!this.state.copyPublicBoard && !isPremiumRequiredModalOpen}
              TransitionComponent={Transition}
              keepMounted
              onClose={this.handleCloseDialog}
              aria-labelledby="dialog-copy-title"
              aria-describedby="dialog-copy-desc"
            >
              <DialogTitle id="dialog-copy-board-title">
                {this.props.intl.formatMessage(messages.copyPublicBoardTitle)}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="dialog-copy-board-desc">
                  {this.props.intl.formatMessage(messages.copyPublicBoardDesc)}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={this.handleCloseDialog}
                  color="primary"
                  disabled={this.state.isSaving}
                >
                  {this.props.intl.formatMessage(messages.boardCopyCancel)}
                </Button>
                <PremiumFeature>
                  <Button
                    onClick={this.handleCopyRemoteBoard}
                    color="primary"
                    variant="contained"
                    disabled={this.state.isSaving}
                  >
                    {this.state.isSaving ? (
                      <LoadingIcon />
                    ) : (
                      this.props.intl.formatMessage(messages.boardCopyAccept)
                    )}
                  </Button>
                </PremiumFeature>
              </DialogActions>
            </Dialog>
            <Dialog
              open={this.state.blockedPrivateBoard}
              TransitionComponent={Transition}
              keepMounted
              onClose={this.handleCloseDialog}
              aria-labelledby="dialog-blocked-title"
              aria-describedby="dialog-blocked-desc"
            >
              <DialogTitle id="dialog-blocked-board-title">
                {this.props.intl.formatMessage(messages.blockedPrivateBoardTitle)}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="dialog-blocked-board-desc">
                  {this.props.intl.formatMessage(messages.blockedPrivateBoardDesc)}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={this.handleCloseDialog}
                  color="primary"
                  variant="contained"
                >
                  {this.props.intl.formatMessage(messages.boardCopyAccept)}
                </Button>
              </DialogActions>
            </Dialog>
            <TileEditor
              editingTiles={editingTiles}
              open={this.state.tileEditorOpen}
              onClose={this.handleTileEditorCancel}
              onEditSubmit={this.handleEditTileEditorSubmit}
              onAddSubmit={this.handleAddTileEditorSubmit}
              boards={boards.filter(
                board =>
                  board !== null &&
                  board.id !== null
              )}
              userData={this.props.userData}
            />
          </Fragment>
        }
      </div>
    );
  }
}

const mapStateToProps = ({
  board,
  communicator,
  speech,
  scanner,
  app: { displaySettings, navigationSettings, userData, isConnected, liveHelp, siteSettings },
  language: { lang },
  subscription: { premiumRequiredModalState }
}) => {
  // const activeCommunicatorId = communicator.activeCommunicatorId;
  // const currentCommunicator = communicator.communicators.find(
  //   communicator => communicator.id === activeCommunicatorId
  // );
  const activeBoardId = isEmpty(board.activeBoardId) ? "root" : board.activeBoardId;

  const emptyVoiceAlert =
    speech.voices.length > 0 && speech.options.voiceURI !== EMPTY_VOICES
      ? false
      : true;
  const offlineVoiceAlert = !isConnected && speech.options.isCloud;

  const activeBoard = board.boards.find(
    board =>
      board !== null &&
      board.id !== null &&
      (board.id === activeBoardId)
  )

  // Show only top-level boards (no parent) in the dropdown
  const communicatorBoards = board.boards.filter(
    b => b !== null && b.id !== null && !b.parent
  );

  return {
    communicator: null,
    currentCommunicator: null,
    board: activeBoard,
    boards: board.boards,
    communicatorBoards,
    output: board.output,
    isLiveMode: board.isLiveMode,
    scannerSettings: scanner,
    navHistory: board.navHistory,
    displaySettings,
    navigationSettings,
    userData,
    emptyVoiceAlert,
    lang,
    offlineVoiceAlert,
    isRootBoardTourEnabled: liveHelp.isRootBoardTourEnabled,
    isUnlockedTourEnabled: liveHelp.isUnlockedTourEnabled,
    isPremiumRequiredModalOpen: premiumRequiredModalState?.open,
    improvedPhrase: board.improvedPhrase,
    navbarPosition: !isEmpty(siteSettings) ? siteSettings.navbarPosition : 'below',
    logoUrl: siteSettings ? siteSettings.logoUrl : '',
    appName: siteSettings ? siteSettings.appName : '',
    tilesPerRow: siteSettings ? siteSettings.tilesPerRow : 0,
    tileSpacing: siteSettings ? siteSettings.tileSpacing : '',
    outputBarPosition: siteSettings ? siteSettings.outputBarPosition : '',
    toolbarLayout: siteSettings ? siteSettings.toolbarLayout : '',
    toolbarPosition: siteSettings ? siteSettings.toolbarPosition : ''
  };
};

const mapDispatchToProps = {
  addBoards,
  changeBoard,
  replaceBoard,
  previousBoard,
  toRootBoard,
  historyRemoveBoard,
  createBoard,
  updateBoard,
  switchBoard,
  createTile,
  deleteTiles,
  editTiles,
  focusTile,
  clickSymbol,
  changeOutput,
  speak,
  cancelSpeech,
  showNotification,
  hideNotification,
  deactivateScanner,
  addBoardCommunicator,
  updateApiObjects,
  updateApiObjectsNoChild,
  downloadImages,
  disableTour,
  createApiBoard,
  upsertApiBoard,
  createApiTile,
  changeDefaultBoard,
  verifyAndUpsertCommunicator,
  upsertApiCommunicator,
  getApiPublicBoards,
  getApiMyBoardsSuccess,
  getApiMyCommunicators,
  editApiTiles,
  deleteApiTiles,
  createApiTiles,
  getProgramLicense,
  reorderApiTiles,
  updateDisplaySettings
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(BoardContainer));
